export default __webpack_public_path__ + "static/media/10.4b61e068.png";